import { render, staticRenderFns } from "./SqlsrvDatabase.vue?vue&type=template&id=8e4f75f2&"
import script from "./SqlsrvDatabase.vue?vue&type=script&lang=js&"
export * from "./SqlsrvDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e4f75f2')) {
      api.createRecord('8e4f75f2', component.options)
    } else {
      api.reload('8e4f75f2', component.options)
    }
    module.hot.accept("./SqlsrvDatabase.vue?vue&type=template&id=8e4f75f2&", function () {
      api.rerender('8e4f75f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/database/SqlsrvDatabase.vue"
export default component.exports